import styled from 'styled-components';

import StyledButton from 'components/Buttons/Button';
import { Form } from 'formik';
import BaseField from 'components/Field';

export const Button = styled(StyledButton)`
  margin-top: 32px;
  font-size: 16px;
  font-weight: 600;
  @media ${({ theme }) => theme.device.desktop} {
    margin-top: 0;
    align-self: flex-end;
  }
`;

export const Field = styled(BaseField)`
  margin-bottom: 16px;
`;


export const FormContainer = styled(Form)`
  overflow-x: hidden;
`;
